<template>
  <div class="rate-points">
    <span v-if="!rate_only" class="rate-points__label">Paghi:</span>
    <div class="rate-points__wrapper">
      <div class="rate-points__content" :id="_uid + '_rate-points'">
        <img :src="icon_url" alt="" />
        <span>{{ amount_points.points }}</span>
      </div>
      <div class="rate-points__content" v-if="amount_points.integration > 0" :id="_uid + '_rate-integration'">
        <span>€ {{ amount_points.integration }}</span>
      </div>
    </div>
    <b-popover
      class="rate-points__popover"
      triggers="hover"
      placement="top"
      v-for="item in popovers"
      :key="item.target"
      :target="item.target"
    >
      <span v-html="item.content" />
    </b-popover>
    <p class="rate-points__currency" v-if="show_eur_total && !rate_only">
      (<span>€ {{ amount_points.live_price }}</span>
      <span>include gestione e assistenza</span>)
    </p>
  </div>
</template>

<script>

export default {
  name: 'rate-points',

  components: {
  },

  props: {
    amount_points: Object,
    rate_only: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      icon_url: "assets/images/common/statics/fallback_loyalty.png",
      show_eur_total: false,
      label: 'punti fedeltà'
    }
  },

  computed: {
    popovers() {
      const list = []
      list.push({
        target: this._uid + '_rate-points',
        content: `<span class="capitalize">${this.label}</span> ${this.amount_points.points}`
      })
      if (this.amount_points.integration > 0) {
        list.push({
          target: this._uid + '_rate-integration',
          content: `Da pagare € ${this.amount_points.integration}`
        })
      }
      return list
    }
  },

  created() {
  },

  mounted() {
    const availability = this.get_availability()
    if (!availability || !availability.points) return

    this.icon_url = availability.points.iconUrl || this.icon_url
    this.show_eur_total = availability.points.showEurTotal
    this.label = availability.points.label || this.label
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  %deco_circle {  //todo : spostare in utilities sass
    &:after {
      content: '';
      width: 4px;
      height: 4px;
      display: inline-block;
      border-radius: $border-radius;
      background-color: $gray-600;
      margin-left: $grid-gutter-width/5;
    }

    &:last-child {
      margin-right: 0;

      &:after {
        display: none;
      }
    }
  }

  .rate-points {
    text-align: center;

    @include media-breakpoint-up(lg) {
      text-align: right;
    }

    &__label {
      display: block;
      font-size: 14px;
      font-weight: $vb-font-weight-semibold;
      margin-top: $grid-gutter-width / 3;
    }

    &__wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    &__content {
      display: flex;
      align-items: center;
      font-size: 24px;
      color: $gray-700;

      & + & {
        &:before {
          content: '+';
          margin: 0 $grid-gutter-width / 6;
        }
      }

      span {
        &:nth-child(2) {
          margin-right: $grid-gutter-width / 10;
        }

        &:last-child {
          font-weight: $vb-font-weight-semibold;
          color: $primary;
        }
      }

      .vb-icon, img {
        max-width: 18px;
        margin-right: $grid-gutter-width / 6;
      }
    }

    &__currency {
      font-size: $font-size-sm;
      color: $gray-600;
      margin-bottom: $grid-gutter-width / 6;

      span {
        @extend %deco_circle;
        margin-right: $grid-gutter-width / 6;

        &:after {
          margin-bottom: 2px;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

</style>